import { SubGroup } from "./subgroup";

export class UserSubGroup {
    userSubGroupID: number;
    userGuid: string;
    subGroupID: number;
    Subgroup: SubGroup;
}